
















import { Component, Vue } from 'vue-property-decorator';
import { updatePassword } from '@/apis/myInfo/myInfo.ts';
import { Toast } from 'vant';
import i18n from '@/lang';

@Component({})
export default class PasswordBInd extends Vue {
  private newPassword: string = '';
  private repeatPassword: string = '';

  keep() {
    //保存密码
    updatePassword({
      newpassword: this.newPassword,
      repeatnewpassword: this.repeatPassword
    })
      .then(res => {
        this.$dialog
          .alert({
            title: i18n.t('Common.提示') as string,
            message: i18n.t('Account.密码修改成功请前去登陆') as string
          })
          .then(() => {
            sessionStorage.clear();
            localStorage.clear();
            this.$router.replace({
              path: '/login'
            });
          });
      })
      .catch(e => {
        // Toast.fail('修改失败')
        // this.$router.go(-1)
      });
  }
  created() {
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('ktpMy.密码设置') as string,
      showTitle: true
    });
  }
}
